import React, { useState } from "react";
import Three_DStyles from "./threeDStyles.module.css";
import Folder from "../../../../assets/Folder.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { ModalComponent } from "../../../../components";
import NewSection from "../UploadSection/UploadSection";

const tds = Three_DStyles;

const Three_D = (props: any) => {
  console.log(props)
  const location = useLocation();
  const { id, key } = location.state || {};
  console.log("ID:", id, location.state);
  console.log("Key:", key);
  const Navigate = useNavigate();
  const [showModal, setShowModal] = useState<boolean>(false);

  //Here the section key is passed as props through navigation, so that you access the section in the fileUpload component.

  console.log("props here", props);
  const handleClick = (section_key: any) => {
    Navigate(`section`, {
      state: { section_key: section_key, project_key: key },
    });
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div>
        <div className={tds.create_sec}>
          <div className={tds.create_text} onClick={() => setShowModal(true)}>
            New Section
          </div>
        </div>
        <div className={tds.card}>
          {props.Three_dDesign?.map((data: any) => {
            console.log(data?.section_name, data?.section_key, data);
            return (
              <p
                className={tds.foldername}
                onClick={() => handleClick(data?.section_key)}
              >
                <span>
                  <img src={Folder} alt="" />
                </span>
                {data?.section_name}
              </p>
            );
          })}
        </div>
        <ModalComponent
          Component={() => (
            <NewSection
              design_template="3d"
              close={handleClose}
              project_key={key}
              getfunction={props?.getfunction}
            />
          )}
          isOpen={showModal}
          onClose={handleClose}
        />
      </div>
    </>
  );
};

export default Three_D;
